import React, { useState } from 'react';
import { BsGithub } from "react-icons/bs";
import { FaGlobe } from "react-icons/fa";
import Modal from 'react-modal';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

Modal.setAppElement('#root');

const ProjectsCard = ({ title, des, src, gallery,githubLink, websiteLink,websiteLink2 }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  return (
    <div className="h-full flex flex-col">
      <div className="h-full w-full p-4 xl:px-12 xl:py-10 rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-gray-900 hover:gray-900 transition-colors duration-1000">
        <div className="w-full h-[80%] overflow-hidden rounded-lg" onClick={openModal}>
          <img
            className="w-full h-60 object-cover group-hover:scale-110 duration-300 cursor-pointer"
            src={src}
            alt="src"
          />
        </div>
        <div className="w-full mt-5 flex flex-col gap-6 flex-grow">
          <div>
            <div className="flex items-center justify-between">
              <h3 className="text-base uppercase text-designColor font-normal">
                {title}
              </h3>
              <div className="flex gap-2">
                {githubLink && (
                  <a href={githubLink} target="_blank" rel="noopener noreferrer">
                    <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                      <BsGithub />
                    </span>
                  </a>
                )}
                {websiteLink && (
                  <a href={websiteLink} target="_blank" rel="noopener noreferrer">
                    <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                      <FaGlobe />
                    </span>
                  </a>
                )}
                {websiteLink2 && (
                  <a href={websiteLink2} target="_blank" rel="noopener noreferrer">
                    <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                      <FaGlobe />
                    </span>
                  </a>
                )}
              </div>
            </div>
            <p className="text-sm tracking-wide mt-3 hover:text-gray-100 duration-300">
              {des}
            </p>
          </div>
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Project Images"
        className="fixed inset-0 flex items-center justify-center pt-20"
        overlayClassName="fixed inset-0 bg-black bg-opacity-75"
      >
        <div className="relative bg-white rounded-lg p-4 max-w-3xl max-h-[80vh] w-full bg-gray-800 overflow-auto">
          <button
            onClick={closeModal}
            className="absolute top-4 right-4 text-red-500 text-2xl font-bold hover:text-red-700"
            style={{ zIndex: 1000 }}
          >
            &times;
          </button>
          <Swiper
            spaceBetween={20}
            slidesPerView={1}
            loop={true}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }}
            modules={[Navigation]}
          >
            {gallery.map((image, index) => (
              <SwiperSlide key={index}>
                <img
                  className="w-full h-auto object-cover rounded-lg"
                  src={image}
                  alt=""
                />
              </SwiperSlide>
            ))}
            <div className="swiper-button-next right-4 top-1/2 transform -translate-y-1/2 text-white text-2xl font-bold cursor-pointer"></div>
            <div className="swiper-button-prev left-4 top-1/2 transform -translate-y-1/2 text-white text-2xl font-bold cursor-pointer"></div>
          </Swiper>
        </div>
      </Modal>
    </div>
  );
}

export default ProjectsCard;
